var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.consultaHistorico")))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.form.consultar_numero,
                        expression: "!form.consultar_numero"
                      }
                    ],
                    staticClass: "form-field select"
                  },
                  [
                    _c("div", { staticClass: "select-field" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.tipo_fecha,
                              expression: "form.tipo_fecha"
                            }
                          ],
                          attrs: { name: "tipoFecha", id: "tipoFecha" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.form,
                                  "tipo_fecha",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.buscar
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { value: "I" } }, [
                            _vm._v(_vm._s(_vm.$t("message.fechaIngreso")))
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "S" } }, [
                            _vm._v(_vm._s(_vm.$t("message.fechaSalida")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "tipoFecha" } }, [
                        _vm._v(_vm._s(_vm.$t("message.tipoFecha")))
                      ]),
                      _vm._v(" "),
                      _vm.errores.tipo_fecha
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.tipo_fecha[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.form.consultar_numero,
                        expression: "!form.consultar_numero"
                      }
                    ],
                    staticClass: "form-field select2"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            id: "patio",
                            options: _vm.patios,
                            label: "name"
                          },
                          on: { input: _vm.inputPatio },
                          model: {
                            value: _vm.selectedPatio,
                            callback: function($$v) {
                              _vm.selectedPatio = $$v
                            },
                            expression: "selectedPatio"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "patio" } }, [
                          _vm._v("Patio")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.form.consultar_numero,
                        expression: "!form.consultar_numero"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("date-picker", {
                          attrs: { type: "date", id: "desde" },
                          on: { enterkey: _vm.buscar },
                          model: {
                            value: _vm.form.desde,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "desde", $$v)
                            },
                            expression: "form.desde"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v(_vm._s(_vm.$t("message.desde")))]),
                        _vm._v(" "),
                        _vm.errores.desde
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.desde[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.form.consultar_numero,
                        expression: "!form.consultar_numero"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("date-picker", {
                          attrs: { type: "hasta", id: "hasta" },
                          on: { enterkey: _vm.buscar },
                          model: {
                            value: _vm.form.hasta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hasta", $$v)
                            },
                            expression: "form.hasta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v(_vm._s(_vm.$t("message.hasta")))]),
                        _vm._v(" "),
                        _vm.errores.hasta
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.hasta[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          multiple: "",
                          id: "tipos_estado",
                          label: "descripcion",
                          options: _vm.optionsEstados
                        },
                        on: { input: _vm.inputTiposEstado },
                        model: {
                          value: _vm.selectedTiposEstado,
                          callback: function($$v) {
                            _vm.selectedTiposEstado = $$v
                          },
                          expression: "selectedTiposEstado"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "tipos_estado" } }, [
                        _vm._v("Estado")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field" }, [
                  _c("p", [
                    _c("label", { attrs: { for: "consultarNumero" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.consultar_numero,
                            expression: "form.consultar_numero"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "consultarNumero",
                          id: "consultarNumero"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.consultar_numero)
                            ? _vm._i(_vm.form.consultar_numero, null) > -1
                            : _vm.form.consultar_numero
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.form.consultar_numero,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "consultar_numero",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "consultar_numero",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "consultar_numero", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("message.filterContainer")))
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.consultar_numero,
                        expression: "form.consultar_numero"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          name: "numeroContenedor",
                          id: "numeroContenedor",
                          placeholder: "#######"
                        },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.buscar.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.form.numero_contenedor,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "numero_contenedor", $$v)
                          },
                          expression: "form.numero_contenedor"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.numeroContenedor")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-info",
                    attrs: { type: "button" },
                    on: { click: _vm.buscar }
                  },
                  [
                    _c("i", { staticClass: "fa fa-search" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.buscar")))])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-responsive mt-3" },
                [
                  _c("k-table", {
                    ref: "consultaHistorico",
                    attrs: {
                      buttons: [
                        {
                          class: "btn-success btn--text",
                          icon: "fa-share",
                          event: "verContenedor"
                        },
                        {
                          class: "btn-info btn--text",
                          icon: "fa-edit",
                          event: "editarContenedor"
                        },
                        {
                          class: "btn-secondary btn--text",
                          icon: "fa-cog",
                          event: "editarPropiedades"
                        }
                      ],
                      noForms: true,
                      params: _vm.form,
                      mostrarTodos: false,
                      columns: _vm.columns,
                      path: _vm.path,
                      deleteButton: false,
                      createButton: false,
                      editButton: false
                    },
                    on: {
                      editarContenedor: _vm.editarContenedor,
                      editarPropiedades: _vm.editarPropiedades,
                      verContenedor: _vm.verContenedor,
                      enviarErrores: _vm.obtenerErrores
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            width: "75%",
            height: "auto",
            scrollable: "",
            name: "edicionHistorico"
          }
        },
        [
          _c("edicion-historico", {
            attrs: {
              esMaquina: _vm.currentIsMaquina,
              number: _vm.currentNumber
            },
            on: {
              aceptar: _vm.aceptarContenedor,
              cancelar: function($event) {
                return _vm.$modal.hide("edicionHistorico")
              }
            },
            model: {
              value: _vm.currentContenedor,
              callback: function($$v) {
                _vm.currentContenedor = $$v
              },
              expression: "currentContenedor"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            width: "75%",
            height: "auto",
            scrollable: "",
            name: "editarPropiedades"
          }
        },
        [
          _c("editar-unidad", {
            ref: "editarUnidad",
            attrs: {
              numeroContenedor: _vm.currentNumber,
              numeroSecuencia: _vm.currentSecuencia,
              puede_editar_status: _vm.puede_editar_status,
              puede_eliminar: _vm.puede_eliminar,
              puede_editar_gate_in: _vm.puede_editar_gate_out,
              puede_editar_gate_out: _vm.puede_editar_gate_out,
              puede_editar_in: _vm.puede_editar_in,
              puede_editar_out: _vm.puede_editar_out,
              puede_editar_caja: _vm.puede_editar_caja,
              puede_editar_maquina: _vm.puede_editar_maquina,
              puede_enviar_edi_in: _vm.puede_enviar_edi_in,
              puede_enviar_edi_out: _vm.puede_enviar_edi_out
            },
            on: {
              cerrarUnidad: _vm.cerrarUnidad,
              eliminarUnidad: _vm.eliminarUnidad
            },
            model: {
              value: _vm.currentUnidad,
              callback: function($$v) {
                _vm.currentUnidad = $$v
              },
              expression: "currentUnidad"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d7b0034", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7b0034","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ConsultaHistorico.vue
// module id = 346
// module chunks = 0